/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState, useLayoutEffect } from 'react'
import {Platform, SafeAreaView} from 'react-native'
import { WebView } from 'react-native-webview';
import styles from './styles';

export default function DealerLocator(props) {
const { navigation } = props;
const payload = "https://empiredistributing.net/products.html";
return (
    <SafeAreaView
    style={styles.container}
    >
        {Platform.OS === 'web' ? (
            <iframe src={payload} height={"100%"} width={"100%"} frameBorder={0}/>
        ) : (
            <WebView
                allowsBackForwardNavigationGestures={true}
                source={{uri : payload}}
            />
        )}
    </SafeAreaView>
)
}